import { createFileRoute } from '@tanstack/react-router'
import React from 'react'

import { PackageCard } from '@/components/klient/profil'
import { NetworkBadge, PersonRow, ProfileRow, SectionLabel, VenueHero } from '@/components/shared'
import { NETWORKS, PACKAGE_ENTITLEMENTS, VENUE, YOUR_PEOPLE } from '@/mocks/klient/profil'

export const Route = createFileRoute('/klient/profil/')({
  head: () => ({ meta: [{ title: 'Profil podniku · Aplikace Bitez' }] }),
  component: KlientProfil,
})

function NetworkHealth() {
  return (
    <span className="flex shrink-0 items-center gap-2.5">
      {NETWORKS.map((network) => (
        <NetworkBadge key={network.icon} network={network} ring="ring-white" />
      ))}
    </span>
  )
}

/** One group: its label, then its content. The GAP between groups is the
 *  separator — Champ headings with a dashed rule shouted louder than anything
 *  they were separating (2026-07-30, after a look at how business profiles
 *  usually solve this). */
function Group({
  label,
  delay = 0,
  children,
}: {
  label: string
  delay?: number
  children: React.ReactNode
}) {
  return (
    <section className="animate-rise-up mt-9" style={{ animationDelay: `${delay}ms` }}>
      <SectionLabel>{label}</SectionLabel>
      <div className="mt-3 space-y-3">{children}</div>
    </section>
  )
}

function KlientProfil() {
  return (
    <div className="px-4 pt-4 pb-6">
      <VenueHero venue={VENUE} />

      <Group label="Vaši lidé">
        <div className="space-y-3.5">
          {YOUR_PEOPLE.map((person) => (
            <PersonRow key={person.name} person={person} />
          ))}
        </div>
      </Group>

      <Group label="Balíček a platby" delay={60}>
        <PackageCard
          name="Degustační menu"
          price="2 990 Kč / týden"
          entitlements={PACKAGE_ENTITLEMENTS}
          billingNote="Karta •••• 4242 · fakturace a faktury"
          billingHref="/klient/profil/fakturace"
        />
      </Group>

      {/* Two doors: what we hold of theirs, and what they configure. The network
          health dots ride on Nastavení, because a dead connection stops
          publishing and must be visible without opening anything. */}
      <div className="animate-rise-up mt-9 space-y-3" style={{ animationDelay: '120ms' }}>
        <ProfileRow
          icon="palette"
          tone="brand"
          title="Podklady"
          note="Brand kit, jídelní a nápojový lístek"
          href="/klient/profil/podklady"
        />
        <ProfileRow
          icon="user"
          title="Nastavení"
          note="Tým, sítě, notifikace, podpora"
          href="/klient/profil/nastaveni"
          trailing={<NetworkHealth />}
        />
      </div>
    </div>
  )
}
